// 면장 원클릭 대기열 (admin) — 실물 파이프라인 PL-3 (2026-07-13)
//   말소완료 ∧ 쇼링완료 ∧ 인보이스 발송 차량을 모아 원클릭으로 면장신청 전이 + 관세사 큐.
//   백엔드: routes/clearancePipeline.js (ready-queue / trigger). DispatchAdmin 패턴 미러.
import React, { useState, useEffect } from 'react';
import { API, authFetch } from '../utils/api';
import CustomModal from './CustomModal';

var NAVY = '#1B3A5C';
var REASON_LABEL = { NO_MAPPING: '관세사 미매핑 — 큐 미생성', NO_COMPANY: '업체 미지정 — 큐 미생성', ALREADY_PENDING: '이미 대기 큐' };

function ClearanceQueueAdmin({ showToast }) {
  var st = showToast || function () {};
  var listState = useState([]); var list = listState[0]; var setList = listState[1];
  var selState = useState({}); var sel = selState[0]; var setSel = selState[1];
  var busyState = useState(false); var busy = busyState[0]; var setBusy = busyState[1];
  var resState = useState(null); var lastResult = resState[0]; var setLastResult = resState[1]; // 최근 트리거 결과 (실패 상세 + reason 요약)
  var modalState = useState(null); var modal = modalState[0]; var setModal = modalState[1];
  var closeModal = function () { setModal(null); };

  function load() {
    authFetch(API + '/clearance/ready-queue').then(function (r) { return r.json(); })
      .then(function (d) { if (d && d.success) { setList(d.items || []); setSel({}); } else st('목록 로드 실패', 'err'); }).catch(function () { st('목록 로드 실패', 'err'); });
  }
  useEffect(function () { load(); }, []);

  function toggle(id) { setSel(function (s) { var n = Object.assign({}, s); if (n[id]) delete n[id]; else n[id] = true; return n; }); }
  function toggleAll() {
    var ready = list.filter(function (c) { return c.docsReady; });
    if (Object.keys(sel).length >= ready.length && ready.length > 0) setSel({});
    else { var n = {}; ready.forEach(function (c) { n[c.id] = true; }); setSel(n); }
  }

  function trigger() {
    var carIds = Object.keys(sel).map(function (x) { return parseInt(x, 10); });
    if (carIds.length === 0) { st('면장 신청할 차량을 선택하세요', 'err'); return; }
    // 네이티브 confirm 대신 공용 CustomModal (앱 모달 체계 통일 — 2026-07-14 V게이트 발견)
    setModal({ type: 'confirm', title: carIds.length + '대를 면장신청 처리할까요?', message: '관세사 매핑된 업체는 큐로 전달됩니다.', confirmText: '면장신청', onConfirm: function () { closeModal(); doTrigger(carIds); } });
  }
  function doTrigger(carIds) {
    if (busy) return;
    setBusy(true);
    authFetch(API + '/clearance/ready-queue/trigger', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ carIds: carIds }) })
      .then(function (r) { return r.json(); })
      .then(function (d) {
        setBusy(false);
        if (d && d.success) {
          // results[] = {carId, ok, error?, noMapping, queued, reason: null|'NO_MAPPING'|'NO_COMPANY'|'ALREADY_PENDING'}
          var results = d.results || [];
          var reasonCnt = {};
          results.forEach(function (x) { if (x.reason) reasonCnt[x.reason] = (reasonCnt[x.reason] || 0) + 1; });
          var summary = Object.keys(reasonCnt).map(function (k) { return (REASON_LABEL[k] || k) + ' ' + reasonCnt[k] + '건'; }).join(' · ');
          var carNoOf = {}; list.forEach(function (c) { carNoOf[c.id] = c.carNo; });
          var fails = results.filter(function (x) { return !x.ok; }).map(function (x) { return { carId: x.carId, carNo: carNoOf[x.carId] || ('#' + x.carId), error: x.error || '실패' }; });
          setLastResult({ okCount: d.okCount, total: d.total, summary: summary, fails: fails });
          st('면장신청 ' + d.okCount + '/' + d.total + '건 처리' + (summary ? ' (' + summary + ')' : '') + (fails.length ? ' — 실패 ' + fails.length + '건 (하단 상세)' : ''), fails.length ? 'err' : '');
          load();
        } else st((d && d.error) || '처리 실패', 'err');
      })
      .catch(function () { setBusy(false); st('처리 실패', 'err'); });
  }

  var readyCount = list.filter(function (c) { return c.docsReady; }).length;
  var selCount = Object.keys(sel).length;

  return (
    <div style={{ padding: '20px 24px', maxWidth: 980, margin: '0 auto' }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: 10, marginBottom: 16 }}>
        <div>
          <div style={{ fontSize: 22, fontWeight: 800, color: NAVY }}>{'📋 면장 대기열'}</div>
          <div style={{ fontSize: 12, color: '#64748b', marginTop: 2 }}>{'말소완료 · 쇼링완료 · 인보이스 발송 차량 → 원클릭 면장신청 (서류 구비 건만 신청 가능)'}</div>
        </div>
        <button onClick={trigger} disabled={busy || selCount === 0} style={{ padding: '10px 22px', background: selCount ? NAVY : '#cbd5e1', color: '#fff', border: 'none', borderRadius: 8, fontSize: 14, fontWeight: 700, cursor: selCount ? 'pointer' : 'default' }}>{'면장신청 (' + selCount + ')'}</button>
      </div>

      <div style={{ overflowX: 'auto', border: '1px solid #e5e7eb', borderRadius: 10 }}>
        <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 13, background: '#fff' }}>
          <thead><tr style={{ background: '#f8fafc' }}>
            <th style={Object.assign({}, thC, { width: 40 })}><input type="checkbox" checked={selCount > 0 && selCount >= readyCount} onChange={toggleAll} disabled={readyCount === 0} /></th>
            <th style={thS}>{'차량번호'}</th><th style={thS}>{'차종'}</th><th style={thS}>{'차대번호(VIN)'}</th><th style={thS}>{'업체'}</th><th style={thC}>{'서류'}</th>
          </tr></thead>
          <tbody>
            {list.length === 0 && <tr><td colSpan={6} style={{ padding: 30, textAlign: 'center', color: '#94a3b8' }}>{'면장 준비된 차량이 없습니다'}</td></tr>}
            {list.map(function (c) {
              return (
                <tr key={c.id} style={{ borderTop: '1px solid #f1f5f9', background: sel[c.id] ? '#eff6ff' : '#fff', opacity: c.docsReady ? 1 : 0.6 }}>
                  <td style={tdC}><input type="checkbox" checked={!!sel[c.id]} disabled={!c.docsReady} onChange={function () { toggle(c.id); }} /></td>
                  <td style={Object.assign({ fontWeight: 700, color: NAVY }, tdS)}>{c.carNo}</td>
                  <td style={tdS}>{c.carType || '-'}</td>
                  <td style={Object.assign({ fontSize: 11, color: '#94a3b8' }, tdS)}>{c.vin || '-'}</td>
                  <td style={tdS}>{c.companyName || '-'}</td>
                  <td style={tdC}>{c.docsReady
                    ? <span style={{ fontSize: 11, fontWeight: 700, color: '#15803d', background: '#f0fdf4', border: '1px solid #bbf7d0', borderRadius: 10, padding: '2px 8px' }}>{'구비'}</span>
                    : <span style={{ fontSize: 11, fontWeight: 700, color: '#dc2626', background: '#fef2f2', border: '1px solid #fecaca', borderRadius: 10, padding: '2px 8px' }}>{'말소증 미비'}</span>}</td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
      {lastResult && (
        <div style={{ marginTop: 10, border: '1px solid #e5e7eb', borderRadius: 10, background: '#fff', padding: '10px 14px', fontSize: 12 }}>
          <div style={{ fontWeight: 700, color: NAVY }}>{'최근 면장신청 결과 — ' + lastResult.okCount + '/' + lastResult.total + '건 처리' + (lastResult.summary ? ' · ' + lastResult.summary : '')}</div>
          {lastResult.fails.map(function (f) {
            return <div key={f.carId} style={{ color: '#dc2626', marginTop: 2 }}>{'❌ ' + f.carNo + ' — ' + f.error}</div>;
          })}
        </div>
      )}
      <div style={{ fontSize: 11, color: '#94a3b8', marginTop: 8 }}>{'면장신청 시 차량 상태가 말소완료 → 면장신청으로 바뀌고, 관세사 매핑된 업체는 관세사 포털 큐에 자동 전달됩니다.'}</div>
      {modal && <CustomModal isOpen={true} {...modal} onCancel={closeModal} />}
    </div>
  );
}

var thS = { padding: '9px 10px', textAlign: 'left', fontWeight: 700, fontSize: 12, color: '#475569' };
var thC = Object.assign({}, thS, { textAlign: 'center' });
var tdS = { padding: '8px 10px', color: '#334155' };
var tdC = Object.assign({}, tdS, { textAlign: 'center' });

export default ClearanceQueueAdmin;
